import React from "react";
import { Navigate } from "react-router-dom";
import { useLearner } from "../../contexts/LearnerContext";
import { translatePath, wordsPath } from "../../utils/routes";
import { MyWords } from "./MyWords";
interface ActivePairRedirectProps {
  section: "words" | "translate";
}

/** /app/words and /app/translate open on the active course pair. */
export function ActivePairRedirect({
  section
}: ActivePairRedirectProps) {
  const {
    activeCourse
  } = useLearner();
  if (section === "translate") {
    return <Navigate to={translatePath(activeCourse?.base ?? "en", activeCourse?.target ?? "es")} replace data-id="element-1252" data-mp="1ep3u62nbho9m" />;
  }
  if (!activeCourse) return <MyWords data-id="element-1253" data-mp="1am75pvb3ixxr" />;
  return <Navigate to={wordsPath(activeCourse)} replace data-id="element-1254" data-mp="1apuwwnt2j89b" />;
}